module.exports = __webpack_public_path__ + "static/img/img_22.5934029c.png";